import { getAPI } from "./base";

/* =================================================================================================================================================
User Account
====================================================================================================================================================*/

export async function fetchAccounts() {
  try {
    const api = getAPI();
    const response = await api.get("/accounts");
    if (response.status === 204) {
      return [];
    }
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching data: ", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}

/* =================================================================================================================================================
User History
====================================================================================================================================================*/

// Get User History
export async function fetchCategoryHistory(filters = {}) {
  try {
    const api = getAPI();
    const response = await api.get("/history", {
      params: filters, // Apply the filters as query parameters
    });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching history: ", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching history: ", error);
  }
}

// SAVE User History
export async function postCategoryHistory(formValues) {
  try {
    const api = getAPI();

    const response = await api.post("/history", null, {
      params: {
        sector: formValues.sector,
        country: formValues.country,
        L1: formValues.category,
        L2: formValues.L2,
        L3: formValues.L3,
        L4: formValues.L4,
      },
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error saving history:", error);
  }
}

// DELETE User History
export async function deleteUserHistory(itemId) {
  const api = getAPI();
  const response = await api.delete(`/history/${itemId}`);
  if (response.status === 200) {
    return response.data;
  }
  throw new Error(`Failed to delete history: ${response.statusText}`);
}

/* =================================================================================================================================================
User Activity
====================================================================================================================================================*/

export async function postActivity(payload) {
  try {
    const api = getAPI();
    const response = await api.post("/user-activity/post_activity", payload);
    return response.data;
  } catch (error) {
    console.error("Error saving activity:", error);
    throw error;
  }
}

export async function patchActivity(sessionId, payload) {
  try {
    const api = getAPI();
    const response = await api.patch(
      `/user-activity/patch_activity/${sessionId}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error appending activity: ", error);
    throw error;
  }
}
